export enum PageUniqueKeys {
  insuranceTertiaryCardExistingClientPageV1 = 'insuranceTertiaryCardExistingClientPageV1',
  insuranceTertiaryCardNewClientPageV1 = 'insuranceTertiaryCardNewClientPageV1',
  clientCheckinPageV1 = 'clientCheckinPageV1',
  profilePicturePage = 'profilePicturePage',
  stripeCreditCardPageV1 = 'stripeCreditCardPageV1',
  stripeCreditCardPage = 'stripeCreditCardPage',
  stripeCreditCardPageDirectoryV1 = 'stripeCreditCardPageDirectoryV1',
  practiceSummaryInformationPage = 'practiceSummaryInformationPage',
  bbgSelfInvitationSelfMatchingClientPgV1 = 'bbgSelfInvitationSelfMatchingClientPgV1',
  selfInvitationSelfMatchingClientPgV1 = 'selfInvitationSelfMatchingClientPgV1',
  lastHiddenPageKey = 'lastHiddenPageKey',
  therapistOnboardingBySchedulerCompletionWelcomeScreenV1 = 'therapistOnboardingBySchedulerCompletionWelcomeScreenV1',
  clientOnboardingBySchedulerWelcomePage = 'clientOnboardingBySchedulerWelcomePage',
  clientOnboardingWelcomePage = 'clientOnboardingWelcomePage',
  intakeCompletionWelcomeScreen = 'intakeCompletionWelcomeScreen',
  intakeCompletionWelcomeScreenDirectoryV1 = 'intakeCompletionWelcomeScreenDirectoryV1',
  intakeCompletionWelcomeScreenVidaV1 = 'intakeCompletionWelcomeScreenVidaV1',
  intakeCompletionNewClientWelcomeScreenV1 = 'intakeCompletionNewClientWelcomeScreenV1',
  intakeCompletionSelfMatchingClientWelcomeScreenV1 = 'intakeCompletionSelfMatchingClientWelcomeScreenV1',
  PracticeAdminIntakeCompletionWelcomeScreenV1 = 'PracticeAdminIntakeCompletionWelcomeScreenV1',
  schedulerIntakeCompletionWelcomeScreenV1 = 'schedulerIntakeCompletionWelcomeScreenV1',
}

export enum ModalQuestionnairePageIds {
  patientAgeGroupInsuranceZipCodePage = 'patientAgeGroupInsuranceZipCodePage',
}

export enum QuestionnaireGroupType {
  INDIVIDUAL_CLIENT_CHECKOUT = 'INDIVIDUAL_CLIENT_CHECKOUT',
  INDIVIDUAL_CLIENT_CHECKIN = 'INDIVIDUAL_CLIENT_CHECKIN',
  SELF_MATCHING_CLIENT_INTAKE = 'SELF_MATCHING_CLIENT_INTAKE',
}

export enum QuestionsUniqueKeys {
  childdateOfBirthSelfMatchingClientQuestionV1 = 'childdateOfBirthSelfMatchingClientQuestionV1',
  yearbeginpracticeTherapistQuestionV1 = 'yearbeginpracticeTherapistQuestionV1',
  yeargraduatedTherapistQuestionV1 = 'yeargraduatedTherapistQuestionV1',
  patientdateofbirthSelfMatchingClientChoiceV1 = 'patientdateofbirthSelfMatchingClientChoiceV1',
  patientsAgeSelfMatchingClientQuestionV1 = 'patientsAgeSelfMatchingClientQuestionV1',
  patientLocation = 'patientLocation',
  benefitsSummaryInsuranceDetailsQuestion = 'benefitsSummaryInsuranceDetailsQuestion',
  inPersonOfficeNickNameQuestion = 'inPersonOfficeNickNameQuestion',
  inPersonOfficeAddressQuestion = 'inPersonOfficeAddressQuestion',
  inPersonOfficeApartmentQuestion = 'inPersonOfficeApartmentQuestion',
  inPersonOfficeCityQuestion = 'inPersonOfficeCityQuestion',
  inPersonOfficeStateQuestion = 'inPersonOfficeStateQuestion',
  inPersonOfficeZipCodeQuestion = 'inPersonOfficeZipCodeQuestion',
  inPersonOfficePictureQuestion = 'inPersonOfficePictureQuestion',
  providerServicesClientQuestion = 'providerServicesClientQuestion',
  insuranceClientQuestion = 'insuranceClientQuestion',
  selfInvitationSelfMatchingDateOfBirthQuestionV1 = 'selfInvitationSelfMatchingDateOfBirthQuestionV1',
}

export enum QuestionnaireQuestionType {
  CUSTOM_SLIDER = 'customslider',
  FILE = 'file',
  DROPDOWN = 'dropdown',
  RADIO = 'radio',
}

export enum QuestionnaireQuestionChoiceUniqueKeys {
  helpMeFindATherapistSelfMatchingClientChoiceV1 = 'helpMeFindATherapistSelfMatchingClientChoiceV1',
  feeTherapistChoiceV1 = 'feeTherapistChoiceV1',
}

export enum QuestionnaireCategoryUniqueKeys {
  goLiveTherapistCtgV1 = 'goLiveTherapistCtgV1',
}
